
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M21.71 11.29L12.71 2.29C12.32 1.9 11.69 1.9 11.3 2.29L8.20996 5.38L13 10.17V7.5L16.15 10.65C16.35 10.85 16.35 11.16 16.15 11.36L15.17 12.34L18.62 15.79L21.71 12.7C22.09 12.32 22.09 11.69 21.71 11.29Z' fill='#323232'/><path d='M6.79012 6.79L3.51012 3.51C3.12012 3.12 2.49012 3.12 2.10012 3.51C1.71012 3.9 1.71012 4.53 2.10012 4.92L5.38012 8.2L2.29012 11.29C1.90012 11.68 1.90012 12.31 2.29012 12.7L11.2901 21.7C11.6801 22.09 12.3101 22.09 12.7001 21.7L15.7901 18.61L19.0701 21.89C19.4601 22.28 20.0901 22.28 20.4801 21.89C20.8701 21.5 20.8701 20.87 20.4801 20.48L6.79012 6.79ZM9.99012 14C9.99012 14.55 9.54012 15 8.99012 15C8.44012 15 7.99012 14.55 7.99012 14V11C7.99012 10.95 8.01012 10.9 8.02012 10.85L9.99012 12.82V14Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-directions-off`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconDirectionsOff

    ```js
    <b-new-b-icon-directions-off />
    ```
</docs>


